import { render, staticRenderFns } from "./Lydiax.vue?vue&type=template&id=3210d21c&"
import script from "./Lydiax.vue?vue&type=script&lang=js&"
export * from "./Lydiax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports